import { DataAssetSource, RevamppDataAsset } from "../../../../shared/entities/data-asset/revampp-data-asset";
import { TableColumnGroup, TableColumnVisibilityControllerV2 } from "../../../../shared/scripts/table-column-visibility";
import { Filter, FilterTab } from "../../../list-management/scripts/list-management.filters";
import { IControllerFilter, JsonItem, PickListItem } from "../../../list-management/scripts/list-management.objects";
import { getDisplayDate } from '../../../../shared/scripts/date-functions';
import { plainToClass } from "class-transformer";
import _ from "lodash";
import { DataAssetModal } from "./data-sharing-assets.modal";
import { TableExport } from "../../../../shared/components/table-export/table-export";
import { DataViewer, DataViewType } from "../../../../shared/components/table-export/data-viewer";

export class DataAssetTable implements IControllerFilter {
    // Config Variables
    tableContainerId: string = "data-asset-table-content";
    getRoute: string = "/secure/data-sharing-hub/data-sharing-assets/data-sharing-assets?handler=Assets";
    refreshRoute: string = "/secure/data-sharing-hub/data-sharing-assets/data-sharing-assets?handler=RefreshAssets"
    loadingContainerId: string = "loading-content-container";
    loadedContentId: string = "loaded-content";
    tableVarName: string = "assetTable";
    lastUpdatedId: string = "asset-refresh-date";
    refreshBtnId: string = "asset-refresh-btn";

    // Table Variables
    id: string = "data-asset-inventory";
    assetList: RevamppDataAsset[];
    pickLists: JsonItem[] = [];
    lastUpdated: Date = new Date(1, 1, 1);
    //sortedPickLists: JsonItem[] = [];
    //allPickLists: JsonItem[] = [];

    assetTable: any;
    tableColumnGroups: TableColumnGroup[];
    tableController: TableColumnVisibilityControllerV2;
    currentTargetItem: any;
    visibleAssets: RevamppDataAsset[] = [];
    viewModal: DataAssetModal;

    filterTabs: FilterTab[];
    columns: any[];
    exportColumns: TableExport;

    constructor() {
        this.columns = [
            {
                data: function (row: RevamppDataAsset, type) {
                    if (type === "sort") {
                        return row.Name;
                    }
                    else if (type === "display" || type === "filter") {
                        return `<span class="view-asset-link font-weight-500" data-id="${row.NdeId}">${row.Name}</span>`
                    }
                    return row.Name;
                },
                title: "Name",
                className: "text-left font-size12 lh-normal table-column-lg"
            },
            { data: "CenterList", title: "Center(s)", className: "general text-left font-size12 lh-normal nowrap", render: (data: string[]) => { return data.sort().join(", ") } },
            { data: "Source", title: "Source", className: "general text-left font-size12 lh-normal nowrap", render: (data: DataAssetSource[]) => { return data.map(source => source.Name).sort().join(", <br>")} },
            { data: "MeasurementTechniqueList", title: "Measurement Technique", className: "general text-left font-size12 lh-normal table-column-md", render: (data: string[]) => { return data.sort().join(", ") } },
            { data: "AuthorList", title: "Contributing Author(s)", className: "general text-left font-size12 lh-normal table-column-lg", render: (data: string[]) => { return data.join(", ") } },
            { data: "PublicationIdList", title: "Citations", className: "general text-left font-size12 lh-normal nowrap", render: (data: string[]) => { return data.map(id => `<a href="https://pubmed.ncbi.nlm.nih.gov/${id}/" target="_blank">${id}<i class="fa-solid fa-up-right-from-square pl-1"></i></a>`).join(", <br>"); } },

            { data: "NdeLink", title: "View in NDE", className: "general text-left font-size12 lh-normal nowrap", render: (data: string) => { return data ? `<a href="${data}" target="_blank">View in NDE<i class="fa-solid fa-up-right-from-square pl-1"></i></a>` : ""} },
            { data: "Url", title: "Repository Link", className: "general text-left font-size12 lh-normal nowrap", render: (data: string) => { return data ? `<a href="${data}" target="_blank">Repository Link<i class="fa-solid fa-up-right-from-square pl-1"></i></a>` : "" } },

            { data: "Type", title: "Asset Type", className: "data-info text-left font-size12 lh-normal nowrap" },
            { data: "HealthConditionList", title: "Health Condition", className: "data-info text-left font-size12 lh-normal table-column-md", render: (data: string[]) => { return data.sort().join(", ") } },
            { data: "InfectiousAgentList", title: "Infectious Agent", className: "data-info text-left font-size12 lh-normal table-column-md", render: (data: string[]) => { return data.sort().join(", ") } },
            { data: "SpeciesList", title: "Species", className: "data-info text-left font-size12 lh-normal table-column-md", render: (data: string[]) => { return data.sort().join(", ") } },
            { data: "TopicCategoryList", title: "Topic Category", className: "data-info text-left font-size12 lh-normal table-column-md", render: (data: string[]) => { return data.sort().join(", ") } },
            { data: "VariablesMeasuredList", title: "Variables Measured", className: "data-info text-left font-size12 lh-normal table-column-md", render: (data: string[]) => { return data.sort().join(", ") } },
            {
                data: function (row: RevamppDataAsset, type) {
                    if (type === "sort") {
                        return row.LastModified;
                    }
                    else if (type === "display" || type === "filter") {
                        return getDisplayDate(row.LastModified);
                    }
                    return getDisplayDate(row.LastModified);
                },
                title: "Last Modified",
                className: "text-left font-size12 lh-normal nowrap"
            },

            { data: "SearchTerms", visible: false, render: (data: string[]) => { return data.join(", ") } },
        ];

        this.filterTabs = [
            new FilterTab("assets-general", "General", "General",
                [
                    new Filter("asset-center-filter", "Center", "deselect-multi-select-list-array", "CenterList"),
                    new Filter("asset-source-filter", "Source", "search-deselect-multi-select-nested-single", "Source", undefined, ["Name"]),
                    new Filter("asset-measurement-tech-filter", "Measurement Technique", "search-deselect-multi-select-list-array", "MeasurementTechniqueList"),
                    new Filter("author-filter", "Contributing Author(s)", "search-deselect-multi-select-list-array", "AuthorList"),
                ]
            ),
            new FilterTab("assets-metadata", "Advanced Search", "Advanced Search",
                [
                    new Filter("asset-type-filter", "Asset Type", "deselect-multi-select", "Type"),
                    new Filter("asset-health-condition-filter", "Health Condition", "search-deselect-multi-select-list-array", "HealthConditionList"),
                    new Filter("asset-inf-agent-filter", "Infectious Agent", "search-deselect-multi-select-list-array", "InfectiousAgentList"),
                    new Filter("asset-species-filter", "Species", "search-deselect-multi-select-list-array", "SpeciesList"),
                    new Filter("asset-topic-cat-filter", "Topic Category", "search-deselect-multi-select-list-array", "TopicCategoryList"),
                    new Filter("asset-var-measured-filter", "Variables Measured", "search-deselect-multi-select-list-array", "VariablesMeasuredList"),
                    new Filter("asset-last-modified", "Last Modified After", "date-after", "LastModified"),
                ]
            )
        ];

        this.tableColumnGroups = [
            new TableColumnGroup("General", true, [], "general"),
            new TableColumnGroup("Advanced Search", false, [], "data-info")
        ]

        this.viewModal = new DataAssetModal();

        this.exportColumns = new TableExport("", [
            new DataViewer("Name", DataViewType.String, "Name"),
            new DataViewer("Description", DataViewType.MultilineString, "Description"),
            new DataViewer("CenterList", DataViewType.StringArray, "Center(s)"),
            new DataViewer("Source", DataViewType.DataAssetSource, "Source"),
            new DataViewer("AuthorList", DataViewType.StringArray, "Contributing Author(s)"),
            new DataViewer("PublicationIdList", DataViewType.StringArray, "Citation ID(s)"),
            new DataViewer("MeasurementTechniqueList", DataViewType.StringArray, "Measurement Technique"),
            new DataViewer("NdeLink", DataViewType.String, "NDE Link"),
            new DataViewer("Url", DataViewType.String, "Repository Link"),
            new DataViewer("Type", DataViewType.String, "Asset Type"),
            new DataViewer("HealthConditionList", DataViewType.StringArray, "Health Condition"),
            new DataViewer("InfectiousAgentList", DataViewType.StringArray, "Infectious Agent"),
            new DataViewer("SpeciesList", DataViewType.StringArray, "Species"),
            new DataViewer("TopicCategoryList", DataViewType.StringArray, "Topic Category"),
            new DataViewer("VariablesMeasuredList", DataViewType.StringArray, "Variables Measured"),
            new DataViewer("LastModified", DataViewType.Date, "Last Modified"),
        ])

        // Initialize View Stuff
        this.initialize();
        this.initializeRefreshBtn();

        $(`#${this.tableContainerId}`).on("click", ".view-asset-link", (e) => {
            let target = $(e.currentTarget);
            let targetId = target.data("id");
            if (targetId) {
                let foundAsset = this.assetList.find(asset => asset.NdeId == targetId);
                if (foundAsset) {
                    this.viewModal.openModal(foundAsset);
                }
            }
        })
    }

    async initialize() {
        this.loadingDisplay(true);

        this.assetList = [];
        this.pickLists = []; // None for Data Assets
        this.lastUpdated = new Date();

        let result: any = await this.getAssets();
        if (result["items"]) {
            this.assetList = plainToClass(RevamppDataAsset, <RevamppDataAsset[]>result["items"]);
        }
        if (result["lastUpdated"]) {
            this.lastUpdated = plainToClass(Date, <Date>result["lastUpdated"]);
        }
        console.log(this.assetList);
        this.exportColumns.initialize(this.pickLists);

        this.createHtmlTemplate();
        this.initializeFilterAndTable();   

        this.updateLastUpdated();
        this.loadingDisplay(false);
        this.resizeTable();
    }

    initializeFilterAndTable() {
        // Filter Tabs
        this.generateFilterTabContent();

        // Select Table
        $(`#${this.id}-table-container`).empty().html(
            `<table id="${this.id}-select-table" class="table table-striped selectable-rows w-100" style="width:100%"></table>`
        )

        // Clear Detail Menu Container
        $(`#${this.id}-detail-menu-container`).empty();

        // Create Table
        this.initializeTable();
    }

    private initializeRefreshBtn(): void {
        $(`#${this.refreshBtnId}`).off("click").on("click", async () => {
            this.loadingDisplay(true);
            await this.refreshAssets();
            this.initialize();
        })
    }

    initializeTable(): void {
        let columns = _.cloneDeep(this.columns);

        let fixedColCount = 1;

        this.assetTable = $(`#${this.id}-select-table`).DataTable({
            "dom": `<"${this.id}-top-controls"<"${this.id}-column-select"><"${this.id}-search-bar"f><"${this.id}-count-found"B>>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            //responsive: false,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: fixedColCount
            },
            language:
            {
                search: "Search",
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    filename: "revampp_shared_data_assets",
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    customize: () => {
                        return this.createCsvData();
                    }
                }
            ],
            data: this.assetList,
            order: [[14, 'desc']], // Sort by last modified  (newest first)
            initComplete: (settings, json) => {

            },
        });

        $(`.${this.id}-top-controls`).addClass('row mx-0 align-items-center');

        $(`.${this.id}-column-select`).addClass('col-12 col-md-3 px-0 mb-2');
        $(`.${this.id}-column-select`).empty().html(`<div id="${this.id}-column-select"></div>`);
        $(`.${this.id}-search-bar`).addClass('col-12 col-md-3');
        $(`.${this.id}-count-found`).addClass('col-12 col-md-6 d-flex justify-content-end vertical-align-middle mt-3 px-0');
        $(`.${this.id}-count-found`).prepend('<div id="selected-items-block" class="align-self-center pr-3"></div>');

        this.tableController = new TableColumnVisibilityControllerV2(`#${this.id}-select-table`, `#${this.id}-column-select`, this.tableColumnGroups, `${this.id}-table-column-visibility`);

        this.updateCount(this.assetList.length);
        this.visibleAssets = this.assetList;
    }

    private loadingDisplay(isLoading: boolean): void {
        if (isLoading) {
            $(`#${this.loadedContentId}`).addClass("d-none");
            $(`#${this.loadingContainerId}`).removeClass("d-none");
        }
        else {
            $(`#${this.loadedContentId}`).removeClass("d-none");
            $(`#${this.loadingContainerId}`).addClass("d-none");
        }
    }

    public triggerFilter() {
        let filteredItems = <any[]>_.cloneDeep(this.assetList);
        this.filterTabs.forEach(tab => {
            tab.filters.forEach(filter => {
                filteredItems = filter.filterItems(filteredItems);
            })
        });

        this.updateTable(filteredItems);
    }

    public resetFilters(): void {
        this.filterTabs.forEach(tab => {
            tab.filters.forEach(filter => {
                filter.resetFilter();
            })
        });

        this.updateTable(this.assetList);
    }

    public updateCount(numItems: number): void {
        let content = "";
        if (numItems == 1) {
            content = "1 Asset Found"
        }
        else {
            content = `${numItems.toString()} Assets Found`
        }

        $(`#${this.id}-table-count-found`).text(content);
    }

    private updateLastUpdated(): void {
        let dateDisplay = getDisplayDate(this.lastUpdated);
        $(`#${this.lastUpdatedId}`).text(dateDisplay);
    }

    updateTable(items: any[]) {
        // Removes any shown menus
        $(`#${this.id}-detail-menu-container`).empty();

        this.assetTable.clear();
        this.assetTable.rows.add(items).draw();
        this.updateCount(items.length);
        this.resizeTable();
        this.visibleAssets = items;
    }

    resizeTable(): void {
        if (this.assetTable) {
            this.assetTable.columns.adjust().draw();
        }
    }

    private async getAssets() {
        let result: any;
        try {
            result = await $.ajax(this.getRoute, {
                method: "GET",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                cache: false
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    private async refreshAssets() {
        let result: any;
        try {
            result = await $.ajax(this.refreshRoute, {
                method: "GET",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                cache: false
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }

    private createHtmlTemplate(): void {
        // Create Content Blocks
        let content = `
            <div id="${this.id}-filter-tab-container" class="d-flex justify-content-between">
                <ul class="nav nav-tabs justify-content-start border-bottom-0" id="${this.id}-filter-tabs" role="tablist">
                    
                </ul>
                <div class="d-flex align-items-center">
                    <div class="font-italic pr-3" id="${this.id}-table-count-found">50 Assets</div>
                    <div>
                        <button class="btn btn-sm btn-outline-secondary font-size12" onclick="page.${this.tableVarName}.resetFilters()">Reset Filters</button>
                    </div>
                </div>
            </div>

            <div class="tab-content edit-table-filter-tab-container" id="${this.id}-filter-container">
                
            </div>

            <div class="edit-table-container mt-4">
                <div class="revampp-datatable border-bottom" id="${this.id}-table-container">
                    
                </div>
            </div>
            <div id="${this.id}-detail-menu-container">

            </div>
        `

        $(`#${this.tableContainerId}`).empty().html(content);

        this.generateFilterTabContent();

    }

    private generateFilterTabContent(): void {
        // Create new Tab Content
        let tabContent = "";
        let filtersContent = "";
        for (let i = 0; i < this.filterTabs.length; i++) {
            let currentFilter = this.filterTabs[i];
            let filterNumber = currentFilter.filters.length;
            if (i == 0) {
                tabContent += `<li class="nav-item"><a class="nav-link active" id="${currentFilter.id}-tab" data-toggle="tab" href="#${currentFilter.id}" role="tab" aria-controls="${currentFilter.id}" aria-selected="true">${currentFilter.displayName}</a></li>`
                filtersContent += `<div class="tab-pane fade show active" id="${currentFilter.id}" role="tabpanel" aria-labelledby="${currentFilter.id}-tab"><div class='row'>`
            }
            else {
                tabContent += `<li class="nav-item"><a class="nav-link" id="${currentFilter.id}-tab" data-toggle="tab" href="#${currentFilter.id}" role="tab" aria-controls="${currentFilter.id}" aria-selected="false">${currentFilter.displayName}</a></li>`
                filtersContent += `<div class="tab-pane fade" id="${currentFilter.id}" role="tabpanel" aria-labelledby="${currentFilter.id}-tab"><div class='row'>`
            }

            for (let j = 0; j < currentFilter.filters.length; j++) {
                let filter = currentFilter.filters[j];
                filtersContent += this.generateFilterHtml(filter, filterNumber);
            }

            filtersContent += `</div></div>`
        }

        // Update Tabs
        $(`#${this.id}-filter-tabs`).empty().html(tabContent);
        $(`#${this.id}-filter-container`).empty().html(filtersContent);

        // Generate Dropdown
        for (let i = 0; i < this.filterTabs.length; i++) {
            let currentFilterTab = this.filterTabs[i];
            for (let j = 0; j < currentFilterTab.filters.length; j++) {
                let currentFilter = currentFilterTab.filters[j];
                this.initializeFilterDropdown(currentFilter);
            }
        }

        this.filterTabs.forEach(tab => {
            if (tab.columnViewName) {
                $(`#${tab.id}-tab`).on('click', () => {
                    $(`#column-filter-dropdown-${this.id}-table-column-visibility`).val([`${tab.columnViewName}`])
                    $(`#column-filter-dropdown-${this.id}-table-column-visibility`).trigger("change");
                })
            }
        });
    }

    private generateFilterHtml(filter: Filter, numberFilters: number): string {
        let content = ""
        if (filter.type == "custom-type") {
            let liveSearch = "";

            content = `
                <div id="${filter.id}-select" class="col-12 col-md-3 mb-2">
                    <div id="${filter.id}-block" class="filter-label d-inline-block label-only">${filter.displayName}</div>
                    <select id="${filter.id}-dropdown" class="selectpicker dropdown" title="None Selected" data-actions-box="true" data-width="100%" data-container="body" data-size="10" ${liveSearch} multiple>
                    </select>
                </div>
            `
        }
        else {
            content = filter.generateFilterHtml();
        }

        // If there's more than 8 filters in a tab, make them smaller (5 per row)
        if (numberFilters > 8) {
            content = content.replace("col-md-3", "col-md-3 col-lg-2");
        }

        return content;
    }

    initializeFilterDropdown(filter: Filter): void {
        if (filter.type == "custom-type") {
            // custom filters
        }
        // traditional filter
        else {
            if (filter.pickListName) {
                let foundPickList: PickListItem[] = this.pickLists.find(list => list.Id == filter.pickListName).Json;
                if (foundPickList) {
                    filter.initializeDropdown(this.assetList, this, foundPickList);
                }
            }
            else {
                filter.initializeDropdown(this.assetList, this);
            }
        }
    }

    getSelectedFilterTabId(): string {
        let selectedTab = $(`#${this.id}-filter-tabs`).find(".active").first();
        return selectedTab.prop("id");
    }

    createCsvData(): string {
        return this.exportColumns.createCsvData(this.visibleAssets);
    }
}